// Which trading card / tabletop game an event is for.
//
// The Square event record has no game field, so it is read from the event's
// name and description (tblevents.description). The name is checked first and
// is the more reliable signal; the description is only used when the name
// does not give the game away (e.g. "Into the Indark Prerelease Event").
//
// Each game lists `name` patterns (tested against the name only, so they can be
// loose: "commander", "modern") and `description` patterns (tested against the
// description, so they must be specific). Magic is last because its words
// ("magic", "commander", "standard") are the most likely to show up in some
// other game's text.
export const OTHER_GAME = { key: 'other', label: 'Other' };

const GAMES = [
  { key: 'pokemon', label: 'Pokémon',
    name: [/pok[eé]mon/i, /gym leader/i, /league (challenge|night|cup)/i],
    description: [/pok[eé]mon/i] },
  { key: 'yugioh', label: 'Yu-Gi-Oh!',
    name: [/yu-?gi-?oh/i, /genesys/i],
    description: [/yu-?gi-?oh/i] },
  { key: 'onepiece', label: 'One Piece',
    name: [/one piece/i, /pirates party/i, /treasure cup/i],
    description: [/one piece/i] },
  { key: 'starwars', label: 'Star Wars: Unlimited',
    name: [/star wars/i],
    description: [/star wars/i] },
  { key: 'unionarena', label: 'Union Arena',
    name: [/union arena/i],
    description: [/union arena/i] },
  { key: 'gundam', label: 'Gundam',
    name: [/gundam/i],
    description: [/gundam card game/i] },
  { key: 'vanguard', label: 'Cardfight!! Vanguard',
    name: [/vanguard/i, /\bvge-/i],
    description: [/vanguard/i] },
  { key: 'dragonball', label: 'Dragon Ball',
    name: [/dragon ?ball/i],
    description: [/dragon ?ball/i] },
  { key: 'riftbound', label: 'Riftbound',
    name: [/riftbound/i],
    description: [/riftbound/i] },
  { key: 'lorcana', label: 'Lorcana',
    name: [/lorcana/i, /into the indark/i],
    description: [/lorcana/i] },
  { key: 'fab', label: 'Flesh and Blood',
    name: [/flesh and blood/i],
    description: [/flesh and blood/i] },
  { key: 'warhammer', label: 'Warhammer',
    name: [/warhammer/i],
    description: [/warhammer/i] },
  { key: 'bloodbowl', label: 'Blood Bowl',
    name: [/blood bowl/i],
    description: [/blood bowl/i] },
  { key: 'beyblade', label: 'Beyblade X',
    name: [/beyblade/i],
    description: [/beyblade/i] },
  { key: 'cyberpunk', label: 'Cyberpunk',
    name: [/cyberpunk/i],
    description: [/cyberpunk/i] },
  { key: 'palworld', label: 'Palworld',
    name: [/palworld/i],
    description: [/palworld/i] },
  { key: 'cookierun', label: 'Cookie Run',
    name: [/cookie run/i],
    description: [/cookie run/i] },
  { key: 'magic', label: 'Magic: The Gathering',
    name: [/\bmagic\b/i, /\bcommander\b/i, /\bmodern\b/i, /\bpauper\b/i, /\brcq\b/i, /star trek/i, /to boldy? go/i],
    description: [/magic: the gathering/i, /magic the gathering/i, /\bmagic\b/i, /planeswalker/i] },
];

const matchesAny = (patterns, text) => patterns.some((p) => p.test(text));

// Returns { key, label } for an event.
export const classifyEvent = (event) => {
  const name = event?.name || '';
  const description = event?.description || '';
  const byName = GAMES.find((g) => matchesAny(g.name, name));
  if (byName) return byName;
  const byDescription = GAMES.find((g) => matchesAny(g.description, description));
  return byDescription || OTHER_GAME;
};
